/**
 * @generated SignedSource<<41c584bdf82af0fed8050ccda4544c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type stepsGearQuery$variables = {
  search?: string | null | undefined;
};
export type stepsGearQuery$data = {
  readonly rentalItems: {
    readonly nodes: ReadonlyArray<{
      readonly assetTag: any;
      readonly category: EquipmentCategory;
      readonly dailyRate: any | null | undefined;
      readonly id: string;
      readonly kitMembers: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly name: string;
    } | null | undefined> | null | undefined;
  };
};
export type stepsGearQuery = {
  response: stepsGearQuery$data;
  variables: stepsGearQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "AssetConnection",
    "kind": "LinkedField",
    "name": "rentalItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dailyRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kitMembers",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stepsGearQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stepsGearQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e4b2c40074fee2248defdf4dfae7ce2e",
    "id": null,
    "metadata": {},
    "name": "stepsGearQuery",
    "operationKind": "query",
    "text": "query stepsGearQuery(\n  $search: String\n) {\n  rentalItems(first: 200, search: $search) {\n    nodes {\n      id\n      assetTag\n      name\n      category\n      dailyRate\n      kitMembers {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac6cee9d6f94a38c81572c3ee569a132";

export default node;
